export { default } from './termBoard';
